import { useWorkspaceText } from '../../interface-copy';
import { downloadText } from '../../api';
import { localDownloadMime, type OfferedDownload } from './local-download';

/**
 * The host Download action for a ready local file. Clicking it is real parent user activation, so the
 * browser download is requested from the parent with the bytes the frame handed over; this says nothing
 * about the file being saved.
 */
export function DownloadOffer({
  offer,
  onDownloaded,
}: {
  offer: OfferedDownload;
  onDownloaded: () => void;
}) {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  return (
    <div className="ws-app-preview-download" role="status">
      <span>{offer.name}</span>
      <button
        type="button"
        className="ws-picker-trigger"
        onClick={() => {
          downloadText(offer.name, offer.text, localDownloadMime(offer.type));
          onDownloaded();
        }}
      >
        {uiText('Download')}
      </button>
    </div>
  );
}
